var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSystemTheme = function SvgSystemTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#71717A",
    d: "M3 12a9 9 0 1 1 18 0 9 9 0 1 1-18 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 5.4c0-.19 0-.286.063-.345.062-.06.154-.054.337-.044a7 7 0 0 1 0 13.978c-.183.01-.275.015-.337-.044C12 18.885 12 18.791 12 18.6z",
    className: "fill-icon-main stroke-icon-main",
    clipRule: "evenodd"
  })));
};
export default SvgSystemTheme;